<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp_FILL0_wght400_GRAD0_opsz24.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Contacto con Tráfico</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding-horizontal">
  <div class="block-content-round ion-text-center">
    <p>{{ 'help.traffic_contact' | translate }}</p>
    <p>
      <a
        href="tel:+34915560075"
        target="_blank"
      >
        +34 915 560 075
      </a>
      <br />
      ({{ 'help.extension' | translate }} 1)
    </p>
    <p>
      <a
        href="mailto:trafico@okcargo.com"
        target="_blank"
      >
        trafico&#64;okcargo.com
      </a>
    </p>
    <p>
      <a
        href="mailto:trafico.internacional@okcargo.com"
        target="_blank"
      >
        trafico.internacional&#64;okcargo.com
      </a>
    </p>
    <p>
      Referencia de la carga:
      <strong>{{ reference }}</strong>
    </p>
  </div>
</ion-content>
